import { DataAnalytics, DataObject } from './common';
export var manageDisputesProps = {
    'data-type': 'manage disputes',
    'data-reason': 'activity',
    'data-object': DataObject.button,
    'data-analytics': DataAnalytics.clickTrackingEvent
};
//# sourceMappingURL=manage-disputes.js.map